import {
  createTheme,
  type CSSVariablesResolver,
  defaultVariantColorsResolver,
  type VariantColorsResolver,
} from '@mantine/core';

import { BadgeOverride } from './overrides/components/badge/badge';
import { DrawerOverride } from './overrides/components/drawer/drawer';
import { MenuOverride } from './overrides/components/menu/menu';
import { ModalOverride } from './overrides/components/modal/modal';
import { MultiSelectOverride } from './overrides/components/multiselect/multiselect';
import { PaperOverride } from './overrides/components/paper/paper';
import { PopoverOverride } from './overrides/components/popover';
import { SimpleGridOverride } from './overrides/components/simple-grid/simple-grid';
import { TextOverride } from './overrides/components/typography/text';
import { TitleOverride } from './overrides/components/typography/title';
const variantColorResolver: VariantColorsResolver = (input) => {
  const defaultResolvedColors = defaultVariantColorsResolver(input);
  if (input.color === 'inverse' && input.variant === 'filled') {
    return {
      ...defaultResolvedColors,
      background: 'light-dark(var(--mantine-color-dark-9), var(--mantine-color-white))',
      color: 'light-dark(var(--mantine-color-white), var(--mantine-color-dark-9))',
    };
  }

  return defaultResolvedColors;
};

export const themeOverride = createTheme({
  components: {
    Badge: BadgeOverride,
    Drawer: DrawerOverride,
    Menu: MenuOverride,
    Modal: ModalOverride,
    MultiSelect: MultiSelectOverride,
    Paper: PaperOverride,
    Popover: PopoverOverride,
    SimpleGrid: SimpleGridOverride,
    Text: TextOverride,
    Title: TitleOverride,
  },
  defaultRadius: 'radius100',
  fontFamily: "'HEX Franklin MLB', sans-serif",
  headings: {
    fontWeight: '700',
    sizes: {
      h1: {
        fontSize: 'var(--text-styles-heading-heading-6-font-size)',
        lineHeight: '1.2',
      },
      h2: {
        fontSize: 'var(--text-styles-heading-heading-5-font-size)',
        lineHeight: '1.2',
      },
      h3: {
        fontSize: 'var(--text-styles-heading-heading-4-font-size)',
        lineHeight: '1.2',
      },
      h4: {
        fontSize: 'var(--text-styles-heading-heading-3-font-size)',
        lineHeight: '1.2',
      },
      h5: {
        fontSize: 'var(--text-styles-heading-heading-2-font-size)',
        lineHeight: '1.2',
      },
      h6: {
        fontSize: 'var(--text-styles-heading-heading-1-font-size)',
        lineHeight: '1.2',
      },
    },
  },
  primaryColor: 'blue',
  primaryShade: 7,
  radius: {
    radius0: '0px',
    radius25: '2px',
    radius50: '4px',
    radius100: '8px',
    radius150: '12px',
    radius200: '16px',
    radius300: '24px',
    radius400: '32px',
    'radius-max': '8000px',
  },
  spacing: {
    space0: '0px',
    space25: '2px',
    space50: '4px',
    space75: '6px',
    space100: '8px',
    space150: '12px',
    space200: '16px',
    space300: '24px',
    space400: '32px',
    space500: '40px',
    space600: '48px',
    space700: '56px',
    space800: '64px',
    space900: '72px',
    space1000: '80px',
  },
  variantColorResolver,
});

export const cssVariableResolver: CSSVariablesResolver = () => ({
  dark: {
    '--mantine-color-body': 'var(--mantine-color-dark-9)',
    '--mantine-color-default': 'var(--mantine-color-dark-7)',
    '--mantine-color-error': 'var(--mantine-color-red-4)',
    '--mantine-color-text': ' var(--mantine-color-white)',
  },
  light: {
    '--mantine-color-body': 'var(--mantine-color-gray-2)',
    '--mantine-color-default': 'var(--mantine-color-white)',
  },
  variables: {},
});
